export default __webpack_public_path__ + "static/media/pokedex-mb-detail-2.cb16456e.png";